import ivclass from '@invideoio/web-shared/Modules/IVClass';
import TextWithStyle from './TextWithStyle';

const SUPPORT_BANNER_TITLE = {
  texts: [
    {
      text: 'Need help finding the right ',
      colorCls: 'iv-text-grey-0',
    },
    {
      text: 'invideo plan',
      colorCls: 'iv-text-hot-pink',
    },
    {
      text: ' for your needs?',
      colorCls: 'iv-text-grey-0',
    },
  ],
};

const Title = () => {
  const fontCls = ivclass(
    'xl:iv-text-heading-s xl:iv-m-heading-s',
    'iv-text-heading-xs iv-m-heading-xs',
    'sm:iv-text-heading-3xs sm:iv-m-heading-3xs',
    'iv-font-extrabold',
  );
  return <TextWithStyle texts={SUPPORT_BANNER_TITLE.texts} fontCls={fontCls} />;
};

export default Title;
